import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import {
	MenuList,
	MenuListItem,
	MenuSection,
	MenuSectionHeading,
} from '@atlassian/navigation-system';
import messages from '../messages.tsx';
import type { RecentItemsType } from '../types.tsx';

export function RenderRecentSection({ recentItems }: { recentItems: RecentItemsType }) {
	const { formatMessage } = useIntl();

	return (
		recentItems.hasItems && (
			<MenuListItem>
				<MenuSection>
					<MenuSectionHeading>{formatMessage(messages.recent)}</MenuSectionHeading>
					<MenuList>{recentItems.list}</MenuList>
				</MenuSection>
			</MenuListItem>
		)
	);
}
